import React, { useCallback } from 'react';

import { Rooms } from '@search/filter-enums/enums';
import Checkbox from '@search/vtbeco-ui/src/components/controls/NewCheckbox';

import { RoomFilter } from '../../../../models/Filter';
import { Filter2, IFilterAvailableProps } from '../../../new_filter/Filter2';
import { CheckboxGroup2, ICheckboxGroupModificationProps } from '../../../common/CheckboxGroup2';

interface IDesktopRoomInFlatFilterViewProps extends IFilterAvailableProps, ICheckboxGroupModificationProps {
    filter: RoomFilter;
    handleChange: (filter: RoomFilter) => void;
}

const selectOptions = [ {
    value: Rooms.ROOM_2,
    label: '2'
}, {
    value: Rooms.ROOM_3,
    label: '3'
}, {
    value: Rooms.ROOM_4,
    label: '4'
}, {
    value: Rooms.ROOM_5_AND_MORE,
    label: '5+'
} ];

export const DesktopRoomInFlatFilterView: React.FC<IDesktopRoomInFlatFilterViewProps> = ({
    filter,
    handleChange,
    withoutTitle,
    classNameGroup
}) => {
    const onChange = useCallback(value => {
        handleChange(new RoomFilter(value));
    }, [ handleChange ]);

    return (
        <Filter2
            filterTitle={withoutTitle ? undefined : 'Комнат в квартире'}
        >
            <CheckboxGroup2
                mode='check'
                onChange={onChange}
                name='roomInFlat'
                value={filter.rooms}
                withoutGrid
                classNameGroup={classNameGroup}
            >
                {selectOptions.map(({ value, label }) => (
                    <Checkbox
                        type='button'
                        view='primary'
                        tone='secondary'
                        key={value}
                        value={value}
                    >
                        {label}
                    </Checkbox>
                ))}
            </CheckboxGroup2>
        </Filter2>
    );
};
